import React, { useState, useEffect } from "react";
import { Card, Container, Col, Row, Modal } from "react-bootstrap";
import { Formik } from "formik";
import * as Yup from "yup";
import Axios from "axios";
import { useParams, useHistory } from "react-router-dom";
import {
  Alert,
  BackButton,
  CreateButton,
  CRUDLayout,
  Input,
  Select,
  CreateModal,
  DeleteModal,
  ActionButton,
  DeleteButton,
  DataStatus,
  SelectSearch,
  SelectMonth,
  DatePicker,
  Table,
  THead,
  TBody,
  Tr,
  ThFixed,
  TdFixed,
  Th,
  Td,
} from "../../../../components";
import { IoSaveOutline } from "react-icons/io5";
import TextArea from "../../../../components/TextArea/TextArea";
// import { IoSaveOutline } from "react-icons/io5";
import { Link } from "react-router-dom";
import { KegiatanAnggaranApi, KategoriAnggaranApi, COAApi } from "../../../../api";
import { RupiahConvert, DateConvert } from "../../../../utilities";

const EditKegiatan = ({ setNavbarTitle }) => {
  // indikator pemanggilan data sedang dimuat di server (loading)
  const [isLoading, setIsLoading] = useState(true);
  // menangani modal form tambah
  const [isCreateForm, setIsCreateForm] = useState(false);
  // menangani modal hapus data
  const [updateData, setUpdateData] = useState([]);
  const [isDeleteData, setIsDeleteData] = useState(false);
  // menampung data yang akan dihapus
  const [deleteData, setDeleteData] = useState([]);
  // configurasi alert
  const [alertConfig, setAlertConfig] = useState({
    variant: "primary",
    text: "",
  });
  const [createSumberDayaAlertConfig, setCreateSumberDayaAlertConfig] = useState({
    show: false,
    variant: 'primary',
    text: 'tes'
  })
  const [showAlert, setShowAlert] = useState(false);
  // Fetch data
  const [data, setData] = useState([]);
  const [dataKaryawan, setDataKaryawan] = useState([]);
  const [dataKategoriSumberDaya, setDataKategoriSumberDaya] = useState([]);
  const [dataCOA, setDataCOA] = useState([]);
  const { id_program, id_kegiatan } = useParams();
  const [tanggalMulai, setTanggalMulai] = useState("");
  const [tanggalSelesai, setTanggalSelesai] = useState("");
  // const [dataForm, setDataForm] = useState([]);
  // request data dari server
  const getData = () => {
    setIsLoading(true);

    // request data ke server
    Axios.all([
      KegiatanAnggaranApi.getFormEdit(id_program, id_kegiatan),
      KegiatanAnggaranApi.getKaryawan(),
      KategoriAnggaranApi.get(),
      COAApi.get(),
    ])
      .then(
        Axios.spread((KegiatanAnggaran, KaryawanAnggaran, KategoriAnggaran, coa) => {
          setData(KegiatanAnggaran.data.data);
          setDataKaryawan(KaryawanAnggaran.data.data);
          setDataKategoriSumberDaya(KategoriAnggaran.data.data);
          setDataCOA(coa.data.data);
        })
      )
      .catch((err) => alert(err))
      .finally(() => setIsLoading(false));
  };

  useEffect(() => {
    // set Judul di Navbar
    setNavbarTitle("Edit Kegiatan");

    // jalankan function request data ke server
    getData();
  }, [setNavbarTitle]);

  // request tambah data ke server
  const formSubmitHandler = (value, { setSubmitting }) => {
    // ** kode dibawah hanya sebagai percobaan, jika api sudah ada harap dihapus dan lakukan fetching data
    setTimeout(() => {
      // stop loading pada button tambah pada modal
      setSubmitting(false);
      // konfigurasi alert
      setAlertConfig({
        variant: "danger",
        text: "Tambah data gagal",
      });
      // menampilkan alert
      setShowAlert(true);
      // menutup modal tambah
      setIsCreateForm(false);
      // request data baru ke server
      getData();
    }, 1000);
  };

  // request hapus data ke server
  const HapusModal = () => {
    const [btnLoading, setBtnLoading] = useState(false);
    // const id_kategori_sumber_daya = [data.sumber_daya];
    useEffect(() => {
      return () => {
        setBtnLoading(false);
      };
    }, []);

    const deleteDataHandler = () => {
      setBtnLoading(true);
      data.sumber_daya.splice(deleteData._rowindex, 1);

      setIsDeleteData(false);
      setShowAlert(true);
      setAlertConfig({
        variant: "primary",
        text: "Hapus data berhasil!",
      });
    };

    return (
      <DeleteModal
        show={isDeleteData}
        onHide={() => setIsDeleteData(false)}
        loading={btnLoading}
        onConfirm={deleteDataHandler}
      >
        Nama sumber daya: {deleteData.item_sumber_daya}
      </DeleteModal>
    );
  };

  // Modal Tambah
  const TambahModal = () => {
    // nilai awal form
    const formInitialValues = {
      id_kategori_sumber_daya: "",
      id_coa: "",
      item_sumber_daya: "",
      qty: "",
      satuan: "",
      harga_satuan: "",
    };
    // skema validasi form
    const formValidationSchema = Yup.object().shape({
      id_kategori_sumber_daya: Yup.string().required("Masukan kategori sumber daya"),
      id_coa: Yup.string().required("Pilih tipe anggaran"),
      item_sumber_daya: Yup.string().required("Masukan item sumber daya"),
      qty: Yup.string().required("Masukan qty"),
      satuan: Yup.string().required("Masukan satuan"),
      harga_satuan: Yup.string().required("Masukan harga satuan"),
    });

    const formSubmitHandler = (value) => {
      data.sumber_daya.push(value)
      setIsCreateForm(false);
      setCreateSumberDayaAlertConfig({
        show: true,
        variant: 'primary',
        text: 'Sumber daya berhasil ditambah!'
      })
    };

    return (
      <CreateModal show={isCreateForm} onHide={() => setIsCreateForm(false)} title="Sumber Daya">
        <Formik
          initialValues={formInitialValues}
          validationSchema={formValidationSchema}
          onSubmit={formSubmitHandler}
        >
          {({
            values,
            errors,
            touched,
            isSubmitting,
            handleChange,
            handleSubmit,
            setFieldValue,
          }) => (
            <form onSubmit={handleSubmit}>
              <Modal.Body>
                <SelectSearch
                  label="Kategori Sumber Daya"
                  type="text"
                  name="id_kategori_sumber_daya"
                  placeholder="Pilih kategori sumber daya"
                  option={dataKategoriSumberDaya.map(val => {
                    return {
                      label: val.nama_kategori_sumber_daya,
                      value: val.id_kategori_sumber_daya
                    }
                  })}
                  onChange={(e) => {
                    let label = e.label;
                    let value = e.value;
                    setFieldValue("id_kategori_sumber_daya", value);
                    setFieldValue("nama_kategori_sumber_daya", label);
                  }}
                  error={errors.id_kategori_sumber_daya && touched.id_kategori_sumber_daya && true}
                  errorText={errors.id_kategori_sumber_daya && touched.id_kategori_sumber_daya && errors.id_kategori_sumber_daya}
                />
                <Input
                  label="Item Sumber Daya"
                  type="text"
                  name="item_sumber_daya"
                  placeholder="Masukan item sumber daya"
                  value={values.item_sumber_daya}
                  onChange={handleChange}
                  error={errors.item_sumber_daya && touched.item_sumber_daya && true}
                  errorText={errors.item_sumber_daya}
                />
                <Input
                  label="Satuan"
                  type="text"
                  name="satuan"
                  placeholder="Masukan satuan"
                  value={values.satuan}
                  onChange={handleChange}
                  error={errors.satuan && touched.satuan && true}
                  errorText={errors.satuan}
                />
                <Row>
                  <div className="col-10">
                    <SelectSearch
                      label="Tipe Anggaran"
                      name="id_coa"
                      placeholder="Pilih tipe anggaran"
                      option={
                        dataCOA
                          ? dataCOA
                            .filter((val) => val.normal_pos === "D")
                            .map((val) => {
                              return {
                                label: `${val.nomor_akun} - ${val.nama_akun}`,
                                value: val.id_coa,
                                normal_pos: val.normal_pos,
                                nomor_akun: val.nomor_akun,
                              };
                            })
                          : {
                            value: "",
                            label: "Pilih tipe anggaran",
                          }
                      }
                      onChange={(val) => {
                        setFieldValue("id_coa", val.value);
                        setFieldValue("nama_akun", val.label);
                        setFieldValue("normal_pos", val.normal_pos);
                        setFieldValue("nomor_akun", val.nomor_akun);
                      }}
                      error={errors.id_coa && touched.id_coa && true}
                      errorText={errors.id_coa && touched.id_coa && errors.id_coa}
                    />
                  </div>
                  <Col>
                    <Input
                      label="Pos"
                      readOnly={true}
                      value={values.normal_pos ? values.normal_pos : "-"}
                    />
                  </Col>
                </Row>
                <Input
                  label="Qty"
                  type="text"
                  name="qty"
                  placeholder="Masukan Qty"
                  value={values.qty}
                  onChange={handleChange}
                  error={errors.qty && touched.qty && true}
                  errorText={errors.qty}
                />
                <Input
                  label="Harga Satuan"
                  type="text"
                  name="harga_satuan"
                  placeholder="Masukan harga satuan"
                  value={RupiahConvert(values.harga_satuan.toString()).detail}
                  onChange={e => {
                    const val = e.target.value
                    const convert = RupiahConvert(val.toString()).default
                    setFieldValue('harga_satuan', Number.isInteger(convert) ? convert : "")
                  }}
                  error={errors.harga_satuan && touched.harga_satuan && true}
                  errorText={errors.harga_satuan}
                />
              </Modal.Body>
              <Modal.Footer>
                <ActionButton
                  type="submit"
                  variant="primary"
                  text="Tambah"
                  className="mt-2 px-4"
                  loading={isSubmitting}
                />
              </Modal.Footer>
            </form>
          )}
        </Formik>
      </CreateModal>
    );
  };

  // nilai awal form
  const formInitialValues = {
    id_kegiatan: data?.kegiatan?.id_kegiatan,
    id_program: data?.program?.id_program,
    tgl_input: data?.kegiatan?.tgl_input,
    no_kegiatan: data?.kegiatan?.no_kegiatan,
    nama_kegiatan: data?.kegiatan?.nama_kegiatan,
    deskripsi_kegiatan: data?.kegiatan?.deskripsi_kegiatan,
    id_karyawan: data?.kegiatan?.id_karyawan,
    tgl_mulai: data?.kegiatan?.tgl_mulai,
    tgl_selesai: data?.kegiatan?.tgl_selesai,
  };

  // skema validasi form
  const formValidationSchema = Yup.object().shape({
    no_kegiatan: Yup.string().required("Masukan no kegiatan"),
    tgl_input: Yup.string().required("Masukan tanggal"),
    nama_kegiatan: Yup.string().required("Masukan nama kegiatan"),
    id_karyawan: Yup.string().required("Masukan nama karyawan"),
  });

  const formSubmitedHandler = (values, { setSubmitting }) => {
    const filterSumberDaya = []

    data.sumber_daya.map(val => filterSumberDaya.push({
      id_coa: val.id_coa,
      id_kategori_sumber_daya: val.id_kategori_sumber_daya,
      item_sumber_daya: val.item_sumber_daya,
      qty: val.qty,
      satuan: val.satuan,
      harga_satuan: val.harga_satuan
    }))

    let finalValues = {
      ...values,
      bulan_tahun: data.program.bulan_dan_tahun,
      sumber_daya: filterSumberDaya
    };

    KegiatanAnggaranApi.update(finalValues)
      .then(() => {
        // konfigurasi alert
        setAlertConfig({
          variant: "primary",
          text: "Ubah data berhasil!",
        });
      })
      .catch((err) => {
        // konfigurasi alert
        setAlertConfig({
          variant: "danger",
          text: `Ubah data gagal! (${err})`,
        });
      })
      .finally(() => {
        setShowAlert(true)
        setSubmitting(false)
        getData()
      });
  };

  const totalSumberDaya = () => {
    let total = 0;

    data.sumber_daya.map((val) => {
      const subTotal = parseInt(val.harga_satuan) * parseInt(val.qty);
      total = total + subTotal;
    });

    return total;
  };

  const InfoItem = ({ title, text }) => (
    <tr>
      <td>{title}</td>
      <td className="pl-4 pr-2">:</td>
      <td>{text}</td>
    </tr>
  )

  return (
    <CRUDLayout>
      {/* Head */}
      <CRUDLayout.Head>{/* Button Section */}</CRUDLayout.Head>

      {/* ALert */}
      <Alert
        show={showAlert}
        showCloseButton={false}
        variant={alertConfig.variant}
        text={alertConfig.text}
      />

      {/* Table Section */}
      {
        // cek apakah data sedang dimuat (loading)
        isLoading === true ? (
          // loading
          <DataStatus loading={true} text="Memuat data..." />
        ) : // Cek apakah ada data
          data !== null ? (
            // Ada data
            <Card className="pb-3">
              <Card.Header className="d-flex justify-content-between">
                <b>Edit Data</b>
                <Link to="/anggaran/transaksi/kegiatan">
                  <BackButton size="sm" />
                </Link>
              </Card.Header>
              <Card.Body>
                <Container>
                  <Row>
                    <Col>
                      <table>
                        <InfoItem
                          title="Departemen"
                          text={data.program.nama_unit_organisasi}
                        />
                        <InfoItem
                          title="Penanggung Jawab"
                          text={data.program.nama_jabatan}
                        />
                        <InfoItem
                          title="Jenis Anggaran"
                          text={data.program.nama_jenis_anggaran}
                        />
                      </table>
                    </Col>
                    <Col>
                      <table>
                        <InfoItem
                          title="Kelompok Anggaran"
                          text={data.program.nama_kelompok_anggaran}
                        />
                        <InfoItem
                          title="Sub Kelompok Anggaran"
                          text={data.program.nama_sub_kelompok_anggaran}
                        />
                        <InfoItem
                          title="Nama Program"
                          text={data.program.nama_program}
                        />
                      </table>
                    </Col>
                  </Row>
                  <hr />
                  <Formik
                    initialValues={formInitialValues}
                    validationSchema={formValidationSchema}
                    onSubmit={formSubmitedHandler}
                  >
                    {({
                      values,
                      errors,
                      touched,
                      isSubmitting,
                      handleChange,
                      handleSubmit,
                      setFieldValue,
                    }) => (
                      <form onSubmit={handleSubmit}>
                        <Row>
                          <Col lg="6">
                            <Input
                              label="Tanggal Kegiatan"
                              type="date"
                              readOnly="readOnly"
                              name="tgl_input"
                              value={values.tgl_input}
                              onChange={(e) => {
                                setFieldValue("tgl_input", e.target.tgl_input);
                                setData({
                                  ...data,
                                  tgl_input: e.target.value,
                                });
                              }}
                              error={errors.tgl_input && touched.tgl_input && true}
                              errorText={errors.tgl_input}
                            />
                          </Col>
                          <Col lg="6">
                            <Input
                              label="No. kegiatan"
                              type="text"
                              readOnly="readOndly"
                              placeholder="Masukan no kegiatan"
                              name="no_kegiatan"
                              value={values.no_kegiatan}
                              onChange={handleChange}
                              error={errors.no_kegiatan && touched.no_kegiatan && true}
                              errorText={errors.no_kegiatan}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col lg="6">
                            <Input
                              label="Nama Kegiatan"
                              type="text"
                              placeholder="Masukan nama kegiatan"
                              name="nama_kegiatan"
                              value={values.nama_kegiatan}
                              onChange={(e) => {
                                setFieldValue("nama_kegiatan", e.target.value);
                                setData({
                                  ...data,
                                  nama_kegiatan: e.target.value,
                                });
                              }}
                              error={errors.nama_kegiatan && touched.nama_kegiatan && true}
                              errorText={errors.nama_kegiatan}
                            />
                          </Col>
                          <Col lg="6">
                            <TextArea
                              label="Keterangan"
                              placeholder="Masukan keterangan"
                              name="deskripsi_kegiatan"
                              value={values.deskripsi_kegiatan}
                              onChange={(e) => {
                                setFieldValue("deskripsi_kegiatan", e.target.value);
                                setData({
                                  ...data,
                                  deskripsi_kegiatan: e.target.value,
                                });
                              }}
                              error={errors.deskripsi_kegiatan && touched.deskripsi_kegiatan && true}
                              errorText={errors.deskripsi_kegiatan}
                              rows={2}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col lg="6">
                            <SelectSearch
                              label="Penanggung Jawab"
                              name="id_karyawan"
                              placeholder="Pilih penanggung jawab"
                              onChange={(val) => {
                                setFieldValue("id_karyawan", val.value);
                                setFieldValue("nama_karyawan", val.value);
                                setData({
                                  ...data,
                                  id_karyawan: val.value,
                                  nama_karyawan: val.label,
                                });
                              }}
                              option={dataKaryawan.map((val) => {
                                return {
                                  value: val.id_karyawan,
                                  label: val.nama_karyawan,
                                };
                              })} //option harus berupa value dan label
                              defaultValue={{
                                value: data?.kegiatan?.id_karyawan ?? "",
                                label: data?.kegiatan?.id_karyawan
                                  ? dataKaryawan.find((val) => val.id_karyawan === data?.kegiatan?.id_karyawan)?.nama_karyawan ?? "" : "Pilih nama karyawan",
                              }}
                              error={errors.id_karyawan && touched.id_karyawan && true}
                              errorText={errors.id_karyawan}
                            />
                          </Col>
                          <Col lg="3">
                            <DatePicker
                              showMonthYearPicker
                              showTwoColumnMonthYearPicker
                              dateFormat="MM/yyyy"
                              label="Periode Mulai"
                              selected={new Date(values.tgl_mulai)}
                              onChange={(date) => {
                                const newDate = DateConvert(new Date(date)).default;

                                setTanggalMulai(date);
                                setFieldValue("tgl_mulai", newDate);
                              }}
                              placeholderText="Pilih tanggal mulai"
                              error={errors.tgl_mulai && touched.tgl_mulai && true}
                              errorText={errors.tgl_mulai}
                            />
                          </Col>
                          <Col lg="3">
                            <DatePicker
                              showMonthYearPicker
                              showTwoColumnMonthYearPicker
                              dateFormat="MM/yyyy"
                              label="Periode Selesai"
                              selected={new Date(values.tgl_selesai)}
                              onChange={(date) => {
                                const newDate = DateConvert(
                                  new Date(date.getFullYear(), date.getMonth() + 1, 0)
                                ).default;
                                // console.log(newDate);
                                setTanggalSelesai(date);
                                setFieldValue("tgl_selesai", newDate);
                              }}
                              placeholderText="Pilih tanggal selesai"
                              error={errors.tgl_selesai && touched.tgl_selesai && true}
                              errorText={errors.tgl_selesai}
                            />
                          </Col>
                        </Row>
                        <hr />
                        <div className="d-flex justify-content-end mb-3">
                          <CreateButton
                            title="Sumber Daya"
                            onClick={() => setIsCreateForm(true)}
                          />
                        </div>
                        <div className="py-2">
                          <b>Daftar Sumber Daya</b>
                        </div>
                        <Alert
                          show={createSumberDayaAlertConfig.show}
                          variant={createSumberDayaAlertConfig.variant}
                          text={createSumberDayaAlertConfig.text}
                          showCloseButton={true}
                          onClose={() => setCreateSumberDayaAlertConfig({
                            ...createSumberDayaAlertConfig,
                            show: false
                          })}
                        />
                        <CRUDLayout.Table>
                          <THead>
                            <Tr>
                              <ThFixed>No</ThFixed>
                              <Th className="text-center">Aksi</Th>
                              <Th>Sumber Daya </Th>
                              <Th>Kategori Anggaran</Th>
                              <Th>Qty</Th>
                              <Th>Satuan</Th>
                              <Th>Harga Satuan</Th>
                              <Th>Sub Total</Th>
                            </Tr>
                          </THead>
                          <TBody>
                            {data.sumber_daya.map((val, index) => {
                              let total;
                              total = val.harga_satuan * val.qty;
                              return (
                                <Tr key={index}>
                                  <TdFixed>{index + 1}</TdFixed>
                                  <Td>
                                    <div className="d-flex justify-content-center">
                                      <DeleteButton
                                        onClick={() => {
                                          setDeleteData({
                                            ...val,
                                            _rowindex: index,
                                          });
                                          setIsDeleteData(true);
                                        }}
                                      />
                                    </div>
                                  </Td>
                                  <Td>{val.item_sumber_daya}</Td>
                                  <Td>{val.nama_kategori_sumber_daya}</Td>
                                  <Td textRight>{val.qty}</Td>
                                  <Td>{val.satuan}</Td>
                                  <Td textRight>
                                    {RupiahConvert(val.harga_satuan.toString()).detail}
                                  </Td>
                                  <Td textRight>{RupiahConvert(total.toString()).detail}</Td>
                                </Tr>
                              );
                            })}
                            <Tr>
                              <td colSpan={7}>
                                <strong>Total</strong>
                              </td>
                              <Td textRight>
                                <strong>{RupiahConvert(totalSumberDaya().toString()).detail}</strong>
                              </Td>
                            </Tr>
                          </TBody>
                        </CRUDLayout.Table>
                        <div className="my-3 d-flex justify-content-end">
                          <ActionButton
                            type="submit"
                            text="Simpan"
                            variant="success"
                            loading={isSubmitting}
                          >
                            <IoSaveOutline className="mr-2" />
                          </ActionButton>
                        </div>
                      </form>
                    )}
                  </Formik>
                </Container>
              </Card.Body>
            </Card>
          ) : (
            // Tidak ada data
            <DataStatus text="Tidak ada data" />
          )
      }

      <TambahModal />
      <HapusModal />
    </CRUDLayout>
  );
};

export default EditKegiatan;
